import type React from "react";
import { type ExternalToast, toast as sonnerToast } from "sonner";
import { Toast, type ToastType } from "./Toast";

const show =
  (type: ToastType) => (message: React.ReactNode, options?: ExternalToast) =>
    sonnerToast.custom(() => <Toast type={type}>{message}</Toast>, options);

export const toast = {
  success: show("success"),
  error: show("error"),
  dismiss: sonnerToast.dismiss,
};
